// extracted by mini-css-extract-plugin
export default {"container":"loadingNoText_container__Bt-Kr","animation":"loadingNoText_animation__hxS22","spinner":"loadingNoText_spinner__dDkTd"};